<template>
  <section id="app" class="content">
    <router-view />
  </section>
</template>
<script>

  $(document).ready(function () {
    $('.sidebar-menu').tree();
  });

  export default {
    name: 'App'
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue